// imports section Start
import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Toolbar,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { OfficerOrdersData } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import { GUEST_API_03 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import OfficerManageOrders from "./OfficerManageOrders";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_PENDING,
  CON_STATUS_RESTAURANTS,
} from "../../utils/sys/Constants";
import ViewData from "../grids/ViewDatagrid";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { GUEST_API_07 } from "../../api/ApiModel";
import { QRCodeSVG } from "qrcode.react";

// imports section End

function OfficerOrders({ onSelectOrder }) {
  // Hooks start
  const [rows, setRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [selectedOrder, setSelectedOrder] = useState(null); // Track the selected order
  const [viewOrder, setViewOrder] = useState(false); // Track whether to show OfficerManageOrders
  const [open, setOpen] = useState(false);
  const [currentQRCode, setCurrentQRCode] = useState(""); // State to store the current QR code value

  useEffect(() => {
    fetchData();
  }, []);
  // Periodic Data Fetch
  useEffect(() => {
    const intervalId = setInterval(fetchData, 5000); // Fetch every 5 seconds
    return () => clearInterval(intervalId); // Cleanup
  }, []);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  // Handlers start

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewOrder = (row) => {
    onSelectOrder(row.details); // Pass selected order to parent
    handleMenuClose();
  };
  // Handlers end

  // API calls start
  const fetchData = async () => {
    try {
      const response = await externalgetApi(GUEST_API_03, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ORDERENDATE: new Date().toISOString().split("T")[0],
        RESSTS: CON_STATUS_RESTAURANTS,
        STSA: CON_STATUS_ACTIVE,
        STSP: CON_STATUS_PENDING,
      });

      console.log("response guest orders", response);
      // Map API data to match table columns
      const mappedRows = response.map((item, index) => ({
        id: index + 1,
        orderRefCode: item.ORDERREFCODE,
        // tableName: item.TABLENAME,
        details: item,
      }));

      // Update state, ensuring no duplicates
      setRows((prevRows) => {
        const existingIds = new Set(prevRows.map((row) => row.orderRefCode));
        const newRows = mappedRows.filter(
          (row) => !existingIds.has(row.orderRefCode)
        );
        return [...prevRows, ...newRows];
      });

      setRows(mappedRows);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };
  const fetchStore = async () => {
    try {
      const params = {
        COMPCODE: COMPCODE,
        LOCCODE: LOCCODE,
        RESTCODE: RESTCODE,
        STS: CON_STATUS_ACTIVE,
      };

      const storeData = await externalgetApi(GUEST_API_07, "GET", params);
      if (storeData.length > 0 && storeData[0].QRCODE) {
        setCurrentQRCode(atob(storeData[0].QRCODE));
        setOpen(true);
      }
      // fetchAllItems(compcode, loccode, restcode);
    } catch (error) {
      setError(error);
    }
  };

  // API calls end

  return (
    <Box
      sx={{
        ...styles.AddStyledBox2,
        mt: { xs: 10, sm: 10, md: 0, lg: 0, xl: 0 },
      }}
    >
      <Toolbar
        sx={{
          maxWidth: "100%",
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          background: theme.palette.background.paper,
          // marginTop: {
          //   xs: "170px",
          //   md: "135px",
          // },
        }}
      >
        <Typography
          variant="h6"
          id="tableTitle"
          component="div"
          sx={{
            ...theme.typography.h2,
            color: theme.palette.text.primary,
            flex: "1 1 100%",
            ml: 1,
          }}
        >
          Orders : {rows.length}
        </Typography>
        <Typography
          variant="h6"
          id="tableTitle1"
          component="div"
          onClick={fetchStore}
          sx={{
            color: theme.palette.text.primary,
            cursor: "pointer",
          }}
        >
          <QrCodeScannerIcon></QrCodeScannerIcon>
        </Typography>
      </Toolbar>
      {/* <Box px={1} pb={1}> */}
      <TableContainer
        sx={{
          ...styles.VI_ViewStyledPaper,
          maxWidth: {
            md: "96%",
            lg: "96%",
            sm: "96%",
            xs: "90%",
          },
          pb: 1,
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ background: theme.palette.background.paper }}>
              {/* <TableCell>#</TableCell> */}
              {/* <TableCell
                sx={{
                  ...styles.AI_headtableCell,
                  textTransform: "capitalize",
                }}
              >
                Table Name
              </TableCell> */}
              <TableCell
                sx={{
                  ...styles.AI_headtableCell,
                  textTransform: "capitalize",
                  textAlign: "left",
                }}
              >
                Order Ref Code
              </TableCell>
              <TableCell
                sx={{
                  ...styles.AI_headtableCell,
                  textAlign: "center",
                  // position: "sticky",
                  right: 0,
                  // background: theme.palette.background.paper,
                  // zIndex: theme.zIndex.appBar,
                  minWidth: "150px", // Set a minimum width for the actions cell
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                {/* <TableCell>{row.id}</TableCell> */}
                {/* <TableCell
                  sx={{
                    ...styles.AI_tablecell,
                  }}
                >
                  {row.tableName}
                </TableCell> */}
                <TableCell
                  sx={{
                    ...styles.AI_tablecell,
                    textAlign: "left",
                  }}
                >
                  {row.orderRefCode}
                </TableCell>
                <TableCell
                  sx={{
                    ...styles.AI_tablecellX,
                    position: "sticky",
                    right: 0,
                    background: theme.palette.background.fill,
                    zIndex: 1,
                  }}
                >
                  <Tooltip title="View Order" arrow placement="right-end">
                    <IconButton onClick={() => handleViewOrder(row)}>
                      <VisibilityIcon
                        sx={{ color: theme.palette.primary.main }}
                      />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          QR Code
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "background.paper",
            p: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              m: 2,
            }}
          >
            <QRCodeSVG value={currentQRCode} size={250} />
          </Box>
        </DialogContent>
      </Dialog>
      {/* </Box> */}
    </Box>
  );
}

export default OfficerOrders;
